module.exports = __webpack_public_path__ + "img/16581289_S.9d2c3232.png";